import { X, Upload, Tag } from "lucide-react";
import { useRef, useState } from "react";
import toast from "react-hot-toast";
import apiRequests from "../axios/config/config";

export default function AddBrandModal({
  open,
  onClose,
  onSuccess,
}) {
  const fileInputRef = useRef(null);

  const [loadingImage, setLoadingImage] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [form, setForm] = useState({
    name: "",
    image: "",
  });

  const [preview, setPreview] = useState("");

  if (!open) return null;

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setLoadingImage(true);

    try {
      const fd = new FormData();
      fd.append("file", file);

      const res = await apiRequests.post(
        "/file/v1/upload-seller",
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        setForm((prev) => ({
          ...prev,
          image: res.data.message._id,
        }));

        setPreview(URL.createObjectURL(file));
      }
    } catch (err) {
      toast.error("Image upload failed.");
    } finally {
      setLoadingImage(false);
    }
  };

const handleSubmit = async () => {
  if (!form.name.trim()) {
    toast.error("Please enter brand name.");
    return;
  }

  if (!form.image) {
    toast.error("Please upload a brand image.");
    return;
  }

  setLoadingSubmit(true);

  try {
    const res = await apiRequests.post("/brand/create-brand-by-seller", form);

    if (res.data.success) {
      toast.success(
        "Your brand request has been submitted. It will be available after admin approval."
      );

      onClose();

      setForm({
        name: "",
        image: "",
      });

      setPreview("");
    }
  } catch (error) {
    console.error(error);
    toast.error("Failed to submit brand request.");
  } finally {
    setLoadingSubmit(false);
  }
};

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-md rounded-3xl bg-white p-7 shadow-xl">

        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Tag className="w-5 h-5" />
            <h2 className="text-xl font-semibold">
              Add Brand
            </h2>
          </div>

          <button onClick={onClose}>
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="mb-5">
          <label className="block mb-2 text-sm font-medium">
            Brand Name
          </label>

          <input
            type="text"
            value={form.name}
            onChange={(e) =>
              setForm({
                ...form,
                name: e.target.value,
              })
            }
            className="w-full h-12 rounded-2xl bg-[#efe5df] px-4 outline-none"
          />
        </div>

        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium">
            Brand Image
          </label>

          {preview ? (
            <div className="relative">
              <img
                src={preview}
                alt=""
                className="w-full h-44 rounded-2xl object-cover"
              />

              <button
                onClick={() => {
                  setPreview("");
                  setForm({
                    ...form,
                    image: "",
                  });
                }}
                className="absolute top-2 right-2 bg-white rounded-full p-1 shadow"
              >
                <X size={18} />
              </button>
            </div>
          ) : (
            <button
              onClick={() => fileInputRef.current.click()}
              className="w-full h-40 border-2 border-dashed border-[#AE9C91] rounded-2xl flex flex-col items-center justify-center gap-2 hover:bg-[#efe5df]/40 transition"
            >
              {loadingImage ? (
                "Uploading..."
              ) : (
                <>
                  <Upload />
                  <span>Upload Brand Image</span>
                </>
              )}
            </button>
          )}

          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            hidden
            onChange={handleUpload}
          />
        </div>

      
        <div className="mt-6 flex justify-end gap-3">
         

          <button
            onClick={handleSubmit}
            disabled={loadingSubmit}
            className="rounded-2xl bg-[#051F33] px-5 py-2 text-white hover:bg-[#082a45]"
          >
            {loadingSubmit ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}